import { createFileRoute } from '@tanstack/react-router';
import { FacebookAdLibraryPage } from '../../../pages/tools/research-tools/FacebookAdLibraryPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/facebook-ad-library')({
  head: () => toolHead('facebook-ad-library'),
  component: FacebookAdLibraryPage,
});
